// Used in many components

import { Injectable } from "@angular/core";
import { CourseMetrics, PPAssignment as Assignment } from "cli-types";

@Injectable()
export class DueDateStatusHelper {
    SUBMITTED_LATE = "submittedLate";
    OVERDUE_BUT_EVALUATED = "overdueButEvaluated";
    OVERDUE = "overdue";
    DUE_TODAY = "dueToday";
    DUE_THIS_WEEK = "dueThisWeek";
    DUE_TODAY_EVALUATED = "dueTodayEvaluated";
    DUE_THIS_WEEK_EVALUATED = "dueThisWeekEvaluated";

    SUBMITTED_LATE_DISPLAY = "Submitted Late";
    SUBMITTED_LATE_EVALUATED_DISPLAY = "Submitted Late and Evaluated";
    OVERDUE_BUT_EVALUATED_DISPLAY = "Overdue but Evaluated";
    OVERDUE_DISPLAY = "Overdue";
    DUE_TODAY_DISPLAY = "Due Today";
    DUE_THIS_WEEK_DISPLAY = "Due This Week";

    constructor() {}

    // Without relying on the Assignment's status value,
    // determine what due date state the assignment is in:
    // due this week, due today, overdue, or late
    public getDueDateStatus(assignment: any) {
        // TODO: This should definitely be Assignment, but the current state of the scores report breaks this
        if (assignment) {
            const dueStatus = assignment.dueStatus;
            const status = assignment.status;
            if (dueStatus === this.SUBMITTED_LATE) {
                return this.SUBMITTED_LATE;
            } else if (dueStatus === this.OVERDUE && status === "evaluated") {
                return this.OVERDUE_BUT_EVALUATED;
            } else if (dueStatus === this.OVERDUE) {
                return this.OVERDUE;
            } else if (dueStatus === this.DUE_TODAY) {
                if (status === "evaluated") {
                    return this.DUE_TODAY_EVALUATED;
                }
                return this.DUE_TODAY;
            } else if (dueStatus === this.DUE_THIS_WEEK) {
                if (status === "evaluated") {
                    return this.DUE_THIS_WEEK_EVALUATED;
                }
                return this.DUE_THIS_WEEK;
            }
        }
    }
    public getDueDateStatusForDisplay(assignment: any) {
        // TODO: This should definitely be Assignment, but the current state of the scores report breaks this
        if (assignment) {
            const dueStatus = assignment.dueStatus;
            const status = assignment.status;
            if (dueStatus === this.SUBMITTED_LATE) {
                if (
                    status === "evaluated" &&
                    (assignment.completedAt || assignment.evaluatedAt)
                ) {
                    return this.SUBMITTED_LATE_EVALUATED_DISPLAY;
                } else {
                    return this.SUBMITTED_LATE_DISPLAY;
                }
            } else if (dueStatus === this.OVERDUE && status === "evaluated") {
                return this.OVERDUE_BUT_EVALUATED_DISPLAY;
            } else if (dueStatus === this.OVERDUE) {
                return this.OVERDUE_DISPLAY;
            } else if (dueStatus === this.DUE_TODAY) {
                let evaluated = "";
                if (assignment.evaluatedAt) {
                    evaluated = " But Evaluated";
                }
                return this.DUE_TODAY_DISPLAY + evaluated;
            } else if (dueStatus === this.DUE_THIS_WEEK) {
                let evaluated = "";
                if (assignment.evaluatedAt) {
                    evaluated = " But Evaluated";
                }
                return this.DUE_THIS_WEEK_DISPLAY + evaluated;
            }
            return null;
        }
    }

    // Show Overdue or Due Today - Used on the Class > Assignments tab list of assignments
    public getDueDateStatusFromCourseMetrics(
        courseMetrics: CourseMetrics,
        cssClass: boolean
    ): string {
        let value = "";
        if (courseMetrics) {
            if (courseMetrics.overdue && courseMetrics.overdue > 0) {
                value = cssClass ? this.OVERDUE : this.OVERDUE_DISPLAY;
            } else if (courseMetrics.dueToday && courseMetrics.dueToday > 0) {
                value = cssClass ? this.DUE_TODAY : this.DUE_TODAY_DISPLAY;
            } else if (courseMetrics.thisWeek && courseMetrics.thisWeek > 0) {
                value = cssClass
                    ? this.DUE_THIS_WEEK
                    : this.DUE_THIS_WEEK_DISPLAY;
            }
        }
        return value;
    }

    // Get Only Due Date Status
    getOnlyDueDateStatus(assignment: Assignment) {
        const dueStatus = assignment.dueStatus;
        if (dueStatus !== this.SUBMITTED_LATE) {
            return dueStatus;
        }
    }
    // Get Only Due Date Status For Display
    getOnlyDueDateStatusForDisplay(assignment: Assignment) {
        const tooltip = this.getDueDateStatusForDisplay(assignment);
        if (tooltip !== this.SUBMITTED_LATE_DISPLAY) {
            return tooltip;
        }
    }

    // Get Only Submitted Date Status
    getOnlySubmittedDateStatus(assignment: Assignment) {
        const dueStatus = assignment.dueStatus;
        if (dueStatus === this.SUBMITTED_LATE) {
            return dueStatus;
        }
    }
    // Get Only Due Date Status For Display
    getOnlySubmittedDateStatusForDisplay(assignment: Assignment) {
        const tooltip = this.getDueDateStatusForDisplay(assignment);
        if (
            tooltip === this.SUBMITTED_LATE_DISPLAY ||
            tooltip === this.SUBMITTED_LATE_EVALUATED_DISPLAY
        ) {
            return tooltip;
        }
    }
}
